export default {"src":"/_next/static/media/waste-removal.7f488bdc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};